import * as THREE from 'three'

import { type Plane, PlanarUVBuilder } from './planar-uv-builder'

export class UVBuilder {
  private geometry: THREE.Geometry

  constructor(geometry: THREE.Geometry) {
    this.geometry = geometry
  }

  public planar(
    plane: Plane,
    vertexIndices: [number, number, number],
    scalingFactor: number = 1,
  ) {
    return new PlanarUVBuilder(
      this.geometry,
      plane,
      vertexIndices,
      scalingFactor,
    )
  }
}
